module.exports = __webpack_public_path__ + "static/img/arishina-earns-rainforest-alliance-certification-against.757891c0.jpeg";